/* ==========================================================================
   TSH PDP rebuild — buy column behaviour (vanilla JS, no jQuery)
   Information tabs: desktop tab bar (one open, active stays open) and
   mobile accordions (all closed by default, toggle independently).
   ========================================================================== */
(function () {
  'use strict';

  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-tab-panel]'));

    function selectTab(tab) {
      var id = tab.getAttribute('data-pdp-tab');

      tabs.forEach(function (t) {
        var selected = t === tab;
        t.classList.toggle('is-selected', selected);
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.setAttribute('tabindex', selected ? '0' : '-1');
      });

      panels.forEach(function (p) {
        p.classList.toggle('is-selected', p.getAttribute('data-pdp-tab-panel') === id);
      });
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        /* Clicking the open tab leaves it open (per spec) */
        if (tab.classList.contains('is-selected')) return;
        selectTab(tab);
      });

      /* Left/right arrow keys move between tabs */
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') {
          next = tabs[(index + 1) % tabs.length];
        } else if (event.key === 'ArrowLeft') {
          next = tabs[(index - 1 + tabs.length) % tabs.length];
        } else {
          return;
        }
        event.preventDefault();
        next.focus();
        selectTab(next);
      });
    });

    /* Mobile accordions — independent toggles, all closed on load */
    Array.prototype.slice.call(root.querySelectorAll('[data-pdp-accordion]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-pdp-tab-panel]');
        if (!item) return;
        var open = item.classList.toggle('is-expanded');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Size guide modal — open/close, focus trap, scroll lock */
  function initSizeGuide() {
    var modal = document.querySelector('[data-size-guide-modal]');
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-size-guide-open]'));
    if (!modal || triggers.length === 0) return;

    var panel = modal.querySelector('[data-size-guide-panel]');
    var lastFocused = null;

    function focusables() {
      return Array.prototype.slice.call(
        panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (items.length === 0) {
        event.preventDefault();
        panel.focus();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      lastFocused = document.activeElement;
      modal.removeAttribute('hidden');
      document.documentElement.classList.add('pdp-modal-open');
      panel.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      modal.setAttribute('hidden', '');
      document.documentElement.classList.remove('pdp-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', open);
    });

    Array.prototype.slice.call(modal.querySelectorAll('[data-size-guide-close]')).forEach(function (el) {
      el.addEventListener('click', close);
    });
  }

  /* Gallery — thumbnail strip, arrows, swipe/dots, variant sync, lightbox */
  function initGallery() {
    var gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-pdp-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-slide]'));
    if (!track || slides.length === 0) return;

    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-thumb]'));
    var thumbsWrap = gallery.querySelector('[data-pdp-thumbs]');
    var thumbsMore = gallery.querySelector('[data-pdp-thumbs-more]');
    var THUMB_PAGE = 5;
    var thumbPage = 0;
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-dot]'));
    var prevBtn = gallery.querySelector('[data-pdp-prev]');
    var nextBtn = gallery.querySelector('[data-pdp-next]');
    var zoomBtn = gallery.querySelector('[data-pdp-zoom]');
    var current = 0;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Thumbnail strip shows four at a time; the arrow pages it (wrapping),
       without moving the main gallery */
    function goToThumbPage(page) {
      if (!thumbsWrap || thumbs.length <= THUMB_PAGE) return;
      var pages = Math.ceil(thumbs.length / THUMB_PAGE);
      thumbPage = ((page % pages) + pages) % pages;
      var target = thumbs[thumbPage * THUMB_PAGE];
      if (!target) return;
      var top = target.offsetTop;
      if (typeof thumbsWrap.scrollTo === 'function') {
        thumbsWrap.scrollTo({ top: top, behavior: reduced ? 'auto' : 'smooth' });
      } else {
        thumbsWrap.scrollTop = top;
      }
    }

    function currentVideo() {
      return slides[current] ? slides[current].querySelector('[data-pdp-video]') : null;
    }

    var muteBtn = gallery.querySelector('[data-pdp-mute]');

    function updateMuteButton() {
      if (!muteBtn) return;
      var video = currentVideo();
      muteBtn.classList.toggle('is-hidden', !video);
      if (video) {
        muteBtn.classList.toggle('is-muted', video.muted);
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }
    }

    function slideIsImage(i) {
      return !!(slides[i] && slides[i].querySelector('[data-pdp-slide-image]'));
    }

    var DOT_WINDOW = 6;

    /* Show at most six dots. Past the fifth slide the active dot holds the
       second-to-last position, so a dot ahead of it always signals more —
       until the window reaches the final slide. */
    function updateDots() {
      if (dots.length <= DOT_WINDOW) return;
      var start = Math.max(0, Math.min(dots.length - DOT_WINDOW, current - (DOT_WINDOW - 2)));
      var end = start + DOT_WINDOW - 1;
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-clipped', idx < start || idx > end);
      });
    }

    /* Track height follows the active slide's natural height */
    function updateStageHeight() {
      var slide = slides[current];
      if (!slide) return;
      var h = slide.offsetHeight;
      if (h > 0) track.style.height = h + 'px';
    }

    /* Autoplay the active slide's video (muted); pause the rest */
    function syncVideos() {
      slides.forEach(function (slide, idx) {
        var video = slide.querySelector('[data-pdp-video]');
        if (!video) return;
        try {
          if (idx === current) {
            video.muted = true;
            var playing = video.play();
            if (playing && typeof playing.catch === 'function') playing.catch(function () {});
          } else {
            video.pause();
          }
        } catch (e) { /* jsdom / very old browsers */ }
      });
    }

    function setActive(i) {
      current = Math.max(0, Math.min(slides.length - 1, i));
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === current); });
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
      updateDots();
      updateStageHeight();
      syncVideos();
      goToThumbPage(Math.floor(current / THUMB_PAGE));
      if (zoomBtn) zoomBtn.classList.toggle('is-hidden', !slideIsImage(current));
      updateMuteButton();
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === slides.length - 1;
    }

    function goTo(i, instant) {
      var target = Math.max(0, Math.min(slides.length - 1, i));
      var left = track.clientWidth * target;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: left, behavior: (instant || reduced) ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = left;
      }
      setActive(target);
    }

    /* Sync active state when the customer swipes/scrolls the track */
    var scrollTimer = null;
    track.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (!track.clientWidth) return;
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      }, 80);
    });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10), false); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-index'), 10), false); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1, false); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1, false); });

    track.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1, false); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1, false); }
    });

    window.addEventListener('resize', function () { goTo(current, true); });

    /* Jump to the variant's featured image on variant change */
    document.addEventListener('pdp:variant-change', function (event) {
      var pos = event.detail && event.detail.mediaPosition;
      if (pos && pos > 0) goTo(pos - 1, false);
    });

    /* Lightbox */
    var lightbox = document.querySelector('[data-pdp-lightbox]');
    if (lightbox && zoomBtn) {
      var lbPanel = lightbox.querySelector('[data-pdp-lightbox-panel]');
      var lbImage = lightbox.querySelector('[data-pdp-lightbox-image]');
      var lbPrev = lightbox.querySelector('[data-pdp-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-pdp-lightbox-next]');
      var lbCloseEls = Array.prototype.slice.call(lightbox.querySelectorAll('[data-pdp-lightbox-close]'));
      var imageSlides = slides.filter(function (s) { return s.querySelector('[data-pdp-slide-image]'); });
      var lbIndex = 0;
      var lbLastFocused = null;

      function lbShow(i) {
        lbIndex = Math.max(0, Math.min(imageSlides.length - 1, i));
        var img = imageSlides[lbIndex].querySelector('[data-pdp-slide-image]');
        lbImage.src = img.getAttribute('data-large') || img.src;
        lbImage.alt = img.alt || '';
        var multi = imageSlides.length > 1;
        if (lbPrev) lbPrev.classList.toggle('is-hidden', !multi);
        if (lbNext) lbNext.classList.toggle('is-hidden', !multi);
      }

      function lbFocusables() {
        return [lbCloseEls[1] || lbCloseEls[0], lbPrev, lbNext].filter(function (el) {
          return el && !el.classList.contains('is-hidden');
        });
      }

      function lbKeydown(event) {
        if (event.key === 'Escape') { lbClose(); return; }
        if (event.key === 'ArrowRight') { lbShow((lbIndex + 1) % imageSlides.length); return; }
        if (event.key === 'ArrowLeft') { lbShow((lbIndex - 1 + imageSlides.length) % imageSlides.length); return; }
        if (event.key !== 'Tab') return;
        var items = lbFocusables();
        if (items.length === 0) { event.preventDefault(); lbPanel.focus(); return; }
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey && (document.activeElement === first || document.activeElement === lbPanel)) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }

      function lbOpen() {
        if (!slideIsImage(current)) return;
        var startAt = imageSlides.indexOf(slides[current]);
        lbLastFocused = document.activeElement;
        lbShow(startAt >= 0 ? startAt : 0);
        lightbox.removeAttribute('hidden');
        document.documentElement.classList.add('pdp-modal-open');
        lbPanel.focus();
        document.addEventListener('keydown', lbKeydown);
      }

      function lbClose() {
        lightbox.setAttribute('hidden', '');
        document.documentElement.classList.remove('pdp-modal-open');
        document.removeEventListener('keydown', lbKeydown);
        if (lbLastFocused && typeof lbLastFocused.focus === 'function') lbLastFocused.focus();
      }

      zoomBtn.addEventListener('click', lbOpen);
      lbCloseEls.forEach(function (el) { el.addEventListener('click', lbClose); });
      if (lbPrev) lbPrev.addEventListener('click', function () { lbShow((lbIndex - 1 + imageSlides.length) % imageSlides.length); });
      if (lbNext) lbNext.addEventListener('click', function () { lbShow((lbIndex + 1) % imageSlides.length); });
    }

    if (thumbsMore) {
      thumbsMore.addEventListener('click', function () { goToThumbPage(thumbPage + 1); });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function () {
        var video = currentVideo();
        if (!video) return;
        video.muted = !video.muted;
        if (!video.muted && video.paused) {
          try {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          } catch (e) {}
        }
        updateMuteButton();
      });
    }

    /* Tap/click a video to toggle play/pause, flashing the new state briefly */
    Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-video-wrap]')).forEach(function (wrap) {
      var video = wrap.querySelector('[data-pdp-video]');
      var flash = wrap.querySelector('[data-pdp-video-flash]');
      var flashTimer = null;
      if (!video) return;
      wrap.addEventListener('click', function () {
        var nowPlaying;
        try {
          if (video.paused) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
            nowPlaying = true;
          } else {
            video.pause();
            nowPlaying = false;
          }
        } catch (e) { return; }
        if (!flash) return;
        flash.classList.toggle('is-playing', nowPlaying);
        flash.classList.add('is-flashing');
        if (flashTimer) clearTimeout(flashTimer);
        flashTimer = setTimeout(function () { flash.classList.remove('is-flashing'); }, 700);
      });
    });

    /* Re-measure the stage once images load in */
    slides.forEach(function (slide, idx) {
      var img = slide.querySelector('img');
      if (!img) return;
      if (img.complete) return;
      img.addEventListener('load', function () {
        if (idx === current) updateStageHeight();
      });
    });

    /* Land on the selected variant's image if there is one */
    var startIndex = parseInt(gallery.getAttribute('data-start-index') || '0', 10);
    goTo(isNaN(startIndex) ? 0 : startIndex, true);
  }

  /* Sticky add-to-basket bar — visibility, states, two-way variant sync */
  function initStickyBar() {
    var bar = document.querySelector('[data-pdp-sticky]');
    if (!bar) return;
    var select = bar.querySelector('[data-pdp-sticky-select]');
    var priceEl = bar.querySelector('[data-pdp-sticky-price]');
    var atb = bar.querySelector('[data-pdp-sticky-atb]');
    var atbPrice = bar.querySelector('[data-pdp-sticky-atb-price]');
    var atbSep = bar.querySelector('.pdp-sticky__atb-sep');
    var atbLabel = bar.querySelector('[data-pdp-sticky-atb-label]');
    var mainAtb = document.querySelector('[data-product-form] .add-to-cart');
    var hasVariants = bar.hasAttribute('data-has-variants');
    var available = bar.hasAttribute('data-available');
    var optionName = (bar.getAttribute('data-option-name') || 'option').toLowerCase();
    var userChose = false;
    var mq = window.matchMedia ? window.matchMedia('(max-width: 769px)') : null;

    function isMobile() { return !!(mq && mq.matches); }

    /* Inline-style enforcement: the dropdown exists on desktop only.
       An inline display wins against any stylesheet rule, stale cache
       or specificity fight. */
    function updateSelectVisibility() {
      if (!select) return;
      /* grid.js wraps selects in a .select-wrapper with its own visible
         .selected-text span — hide the wrapper, not just the select */
      var target = (select.closest && select.closest('.select-wrapper')) || select;
      target.style.display = isMobile() ? 'none' : '';
      if (target !== select) select.style.display = isMobile() ? 'none' : '';
    }

    /* Keep the theme wrapper's visible label in sync when we set the
       select programmatically (its own listener only hears native events) */
    function updateSelectLabel() {
      if (!select || !select.closest) return;
      var wrapper = select.closest('.select-wrapper');
      if (!wrapper) return;
      var label = wrapper.querySelector('.selected-text');
      var opt = select.options[select.selectedIndex];
      if (label && opt) label.textContent = opt.textContent.trim();
    }

    function updateButton() {
      updateSelectVisibility();
      var state;
      if (!available) state = 'notify';
      else if (isMobile() && hasVariants && !userChose) state = 'select';
      else state = 'add';
      bar.setAttribute('data-state', state);
      if (state === 'notify') atbLabel.textContent = 'Notify when available';
      else if (state === 'select') atbLabel.textContent = 'Select a ' + optionName;
      else atbLabel.textContent = 'Add to Bag';
      var showPrice = state === 'add';
      if (atbPrice) atbPrice.hidden = !showPrice;
      if (atbSep) atbSep.hidden = !showPrice;
    }

    /* Show once the main Add to Bag is out of view; hide when it returns */
    var watchTarget = mainAtb || document.querySelector('.pdp-buy-row');
    if (watchTarget && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        /* only once the button has scrolled up out of view (user is below
           it) — not while it is still further down the page */
        var passed = entry.boundingClientRect && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', !entry.isIntersecting && passed);
      }, { threshold: 0 });
      io.observe(watchTarget);
    }

    /* Bar dropdown -> main buy box (drives the existing radio handler) */
    if (select) {
      select.addEventListener('change', function () {
        userChose = true;
        var radio = document.querySelector('input[data-variant-radio][value="' + select.value + '"]');
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          var hidden = document.querySelector('.hidden-variant-select');
          if (hidden) {
            hidden.value = select.value;
            hidden.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        updateButton();
      });
    }

    /* Main buy box -> bar (price, availability, dropdown position) */
    document.addEventListener('pdp:variant-change', function (event) {
      var d = event.detail || {};
      userChose = true;
      if (typeof d.available === 'boolean') available = d.available;
      if (select && d.variantId) {
        select.value = d.variantId;
        updateSelectLabel();
      }
      if (d.priceFormatted) {
        /* the shop's money format uses HTML entities (&pound;) — innerHTML,
           matching the theme's own price handler */
        if (priceEl) priceEl.innerHTML = d.priceFormatted;
        if (atbPrice) atbPrice.innerHTML = d.priceFormatted;
      }
      updateButton();
    });

    if (mq) {
      if (typeof mq.addEventListener === 'function') mq.addEventListener('change', updateButton);
      else if (typeof mq.addListener === 'function') mq.addListener(updateButton);
    }

    atb.addEventListener('click', function () {
      var state = bar.getAttribute('data-state');
      if (state === 'notify') {
        var bis = document.getElementById('BIS_trigger');
        if (bis) { bis.click(); return; }
      }
      if (state === 'select' || state === 'notify') {
        var row = document.querySelector('.pdp-size-row-head') ||
          document.querySelector('.product-options') ||
          document.querySelector('.product-details');
        if (row && typeof row.scrollIntoView === 'function') {
          row.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      if (mainAtb && !mainAtb.disabled) mainAtb.click();
    });

    updateButton();
  }

  /* Instalment line under the price — follows variant changes */
  function initKlarnaLine() {
    var amount = document.querySelector('[data-pdp-klarna-amount]');
    if (!amount) return;
    document.addEventListener('pdp:variant-change', function (event) {
      var d = event.detail || {};
      if (d.priceThirdFormatted) amount.innerHTML = d.priceThirdFormatted;
    });
  }


  /* Judge.me write-review modal.

     The modal is app-rendered, so there is no open/close hook to attach to and
     no reliable click target (the trigger is inside the app's own widget). We
     watch the document for the modal's content element instead and mirror its
     visibility onto the same `pdp-modal-open` class the size guide and gallery
     lightbox use — which is what suppresses the mobile sticky bar. Without it
     the sticky bar sits over the form's Next button.

     Presence alone is not enough: the modal may stay in the DOM between opens,
     so visibility is checked via offsetParent. */
  function initReviewFormWatcher() {
    var SELECTOR = '.jdgm-write-review-modal__content';
    var isOpen = false;

    function visible(el) {
      return !!el && el.offsetParent !== null;
    }

    function sync() {
      var open = visible(document.querySelector(SELECTOR));
      if (open === isOpen) return;
      isOpen = open;
      document.documentElement.classList.toggle('pdp-modal-open', open);
    }

    var observer = new MutationObserver(sync);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });

    sync();
  }


  /* Back-in-stock button.

     Restock Rocket doesn't attach to the buy column — it only renders its own
     floating side tab — so our button borrows that tab as the trigger and the
     tab is then hidden by CSS.

     The button stays hidden until the tab is found. If the app is slow, absent,
     or later removed, the customer sees the plain "Sold out" state rather than a
     button that silently does nothing. */
  function initNotifyButton() {
    var btn = document.querySelector('[data-pdp-notify]');
    if (!btn) return;

    var input = document.querySelector('.pdp-buy-row input.add-to-cart');

    function trigger() {
      /* Our own #BIS_trigger hook first — always present, so the button no
         longer waits on an app to inject anything. The Restock Rocket elements
         remain as a fallback only for as long as both apps are installed; once
         Restock Rocket is removed these two selectors simply never match.
         (Its cover sits above its button at z-index 600 and takes the click.) */
      return document.querySelector('[data-pdp-notify-hook]') ||
        document.querySelector('.restock-rocket-button-cover') ||
        document.querySelector('.restock-rocket-button-product');
    }

    function soldOut() {
      return !!input && input.classList.contains('disabled');
    }

    var wrapper = document.querySelector('.product-form-content-wrapper');

    function sync() {
      var unavailable = soldOut();
      var show = unavailable && !!trigger();

      btn.hidden = !show;
      if (input) input.hidden = show;
      document.documentElement.classList.toggle('pdp-notify-active', show);

      /* Independent of whether the app is reachable: an unavailable variant
         should never offer express checkout or a quantity stepper. */
      if (wrapper) {
        wrapper.classList.toggle('pdp-variant-unavailable', unavailable);
      }

      return show;
    }

    btn.addEventListener('click', function () {
      var el = trigger();
      if (el) el.click();
    });

    /* The app injects its trigger asynchronously, and on a part-stocked product
       it isn't on the page at all until an out-of-stock variant is selected —
       which is later than any one-shot watch at page load would cover. So the
       watch is re-armed on every variant change rather than run once.

       Each window is time-boxed so we're not observing the whole document for
       the life of the page. */
    var observer = null;
    var timer = null;

    function stopWatching() {
      if (observer) { observer.disconnect(); observer = null; }
      if (timer) { window.clearTimeout(timer); timer = null; }
    }

    function watch() {
      if (sync()) return;
      stopWatching();
      observer = new MutationObserver(function () {
        if (sync()) stopWatching();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      timer = window.setTimeout(stopWatching, 8000);
    }

    /* Variant switching is handled by the inline script in the buy column, which
       flips the input's disabled class; re-check after it has run. */
    document.addEventListener('pdp:variant-change', function () {
      window.setTimeout(watch, 0);
    });

    watch();
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('[data-pdp-tabs]')).forEach(initTabs);
    initSizeGuide();
    initGallery();
    initStickyBar();
    initKlarnaLine();
    initReviewFormWatcher();
    initNotifyButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
